import React from 'react';
import { prepareData } from 'utils/googleData';
import { formattedDate } from 'utils/dateutils';

const FeaturedImage = ({ featuredImg }) => {
    return (
        <div className="relative w-full self-start before:absolute before:-bottom-3 before:-right-3 before:h-full before:w-full before:rounded-sm before:bg-gray-accent">
            <img className="relative w-full" src={featuredImg} alt="Event Visual" />
        </div>
    );
};

export const WhereWhen = (props) => {
    const {
        enable,
        parent,
        venue,
        eventDate,
        from,
        to,
        gatsbyImage,
        gatsbyImageSrc
    } = prepareData({ props });

    const featuredImg = gatsbyImageSrc || parent?.cover?.image?.publicURL;
    const eventVenue = venue || parent?.places;
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return null;
    }

    return (
        <>
            <div className="mb-4 flex flex-col sm:flex-row justify-between border-t border-dashed border-gray-accent-light pt-4 sm:mb-0">
                <div className="sm:w-1/2">
                    <h4 className="opacity-50 mb-1 text-lg">
                        Where
                    </h4>
                    <p className="font-semibold text-md">
                        {eventVenue?.name || "Online Event"}
                        <br />
                        {eventVenue?.address && (
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
                                href={`https://www.google.com/maps/place/${encodeURIComponent(eventVenue?.address)}`}
                            >
                                View Map
                            </a>
                        )}
                    </p>
                </div>
                <div className="sm:w-1/2 mt-4 sm:mt-0">
                    <h4 className="opacity-50 mb-1 text-lg">
                        When
                    </h4>
                    <p className="font-semibold text-md">
                        {formattedDate(eventDate)}

                    <br />
                    {from} - {to}
                </p>
            </div>
        </div>
      {featuredImg &&  <FeaturedImage featuredImg={featuredImg} /> }
        </>
    )
}
export default WhereWhen
